import React, { useEffect, useState } from "react";
import { StyleSheet, css } from "aphrodite";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Dashboard from "../../../services/api/dashboard";

const styles = StyleSheet.create({
  card: {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    marginTop: 16,
    width: "100%",
    overflow: "hidden",
    transition: "all 0.3s ease",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: "16px 20px 12px 20px",
    borderBottom: "1px solid #f0f0f0",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: "#1a1a1a",
    margin: 0,
  },
  content: {
    padding: "20px",
    textAlign: "center",
  },
  numberContainer: {
    background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
    borderRadius: 12,
    padding: "24px 20px",
    border: "1px solid #e2e8f0",
    transition: "all 0.3s ease",
    ":hover": {
      transform: "scale(1.02)",
      boxShadow: "0 8px 25px rgba(59, 130, 246, 0.15)",
    },
  },
  number: {
    fontSize: 48,
    fontWeight: 700,
    lineHeight: 1,
    marginBottom: 8,
    background: "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    userSelect: "none",
  },
  label: {
    fontSize: 14,
    color: "#6b7280",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
});

function GohonzonMembers() {
  const [totalMembers, setTotalMembers] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await Dashboard.gohonzonMembersCount();
        console.log("API Response:", response);
        if (typeof response?.data === "number") {
          setTotalMembers(response.data);
        } else {
          throw new Error("Unexpected response structure");
        }
      } catch (err) {
        console.error("Error fetching gohonzon members:", err);
        // setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  let content;
  if (loading) {
    content = <div className={css(styles.label)}>Loading...</div>;
  } else if (error) {
    content = (
      <div className={css(styles.label)} style={{ color: "red" }}>
        {error}
      </div>
    );
  } else {
    content = (
      <>
        <div className={css(styles.number)}>
          {totalMembers?.toLocaleString()}
        </div>
        {/* <div className={css(styles.label)}>Total Members</div> */}
      </>
    );
  }

  return (
    <div className={css(styles.card)}>
      <div className={css(styles.header)}>
        <h3 className={css(styles.title)}>Gohonzon Members</h3>
        {/* <InfoOutlinedIcon fontSize="small" style={{ color: "#999" }} /> */}
      </div>

      <div className={css(styles.content)}>
        <div className={css(styles.numberContainer)}>{content}</div>
      </div>
    </div>
  );
}

export default GohonzonMembers;
